module.exports = __webpack_public_path__ + "img/hmm_icon.3b36542b.png";